import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';

interface Props {
    title: string;
}

const useStyle = makeStyles((theme) => ({
    root: {
        fontWeight:500,
        whiteSpace: 'nowrap',
        margin: '130px 0px 80px 100px',
        alignSelf: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            margin: '3em 1em'
        }
    }
}));

const CommonTitle = ({ title }: Props) => {
    const classes = useStyle();
    return (
        <Typography color="textPrimary" variant="h5" className={classes.root}>
            {title}
        </Typography>
    );
};

export default CommonTitle;
